export interface IUpCasedKeyValue {
    Key: string | number;
    Value: string;
}

export class StringDictionary extends Array<IUpCasedKeyValue> implements IStringDictionary {
    constructor(d: IStringDictionary | number | void) {
        if (typeof(d) === "number") super(d);
        else if (d) super(...d);
        else super();
    }

    static fromSimpleObject(obj: any): StringDictionary {
        const result = new StringDictionary();
        for (const prop in obj) {
            if (obj.hasOwnProperty(prop))
                result.set(prop, obj[prop]);
        }
        return result;
    }

    containsKey(key: string | number): boolean {
        const idx = this.findIndex(kv => { return kv.Key === key });
        return idx > -1;
    }
    get(key: string | number): string {
        return this.find(kv => { return kv.Key === key })?.Value ?? "";
    }
    set(key: string | number, value: string) {
        this.remove(key);
        this.push({Key: key, Value: value});
    }
    remove(key: string | number) {
        const idx = this.findIndex(kv => { return kv.Key === key });
        if (idx > -1)
            this.splice(idx, 1);
    }
    aggregate(seed: string, accumulator: (current: string, pair: IUpCasedKeyValue) => string): string {
        let current = seed;
        this.forEach(kvPair => {
            current = accumulator(current, kvPair);
        })
        return current;
    }
}

export interface IStringDictionary extends Array<IUpCasedKeyValue> {
    length: number;
    containsKey(key: string): boolean;
    get(key: string | number): string;
    set(key: string | number, value: string): void;
    remove(key: string | number): void;
}